/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addCoachPaymentMethodForAdmin,
  addCustomerPaymentMethod,
} from "../redux/Slices/leadOfferSlice";
import appInsights from "../AppInsights";

const StripeCoachSuccess = () => {
  const dispatch = useDispatch();
  const [sessionId, setSessionId] = useState(
    localStorage.getItem("checkoutSessionId") || ""
  );
  const [leadOfferDetailsId, setLeadOfferDetailsId] = useState(
    localStorage.getItem("payment_LeadOfferDetailsId") || ""
  );

  const [isCoach, setIsCoach] = useState(
    localStorage.getItem("isCoach") === "true"
  );
  const [isAdminCoach, setIsAdminCoach] = useState(
    localStorage.getItem("isAdminCoach") === "true"
  );

  const { checkoutSession, loading, error } = useSelector(
    (state) => state.leadOffer
  );

  // Track page view on component mount
  useEffect(() => {
    appInsights.trackPageView({
      name: "StripeCoachSuccess",
      properties: {
        page: "StripeCoachSuccess",
        userType: isCoach ? "coach" : isAdminCoach ? "adminCoach" : "unknown",
        isCoach: isCoach,
        isAdminCoach: isAdminCoach,
        hasSessionId: !!sessionId,
        hasLeadOfferDetailsId: !!leadOfferDetailsId,
        leadOfferDetailsId: leadOfferDetailsId || "not_available",
        timestamp: new Date().toISOString(),
        source: "stripe_checkout_redirect",
      },
    });
  }, []);

  // Update sessionId if checkoutSession changes
  useEffect(() => {
    if (checkoutSession?.id) {
      setSessionId(checkoutSession.id);
    }
  }, [checkoutSession]);

  // Process payment method when sessionId is available
  useEffect(() => {
    if (sessionId) {
      if (isCoach) {
        // Track coach payment processing start
        appInsights.trackEvent({
          name: "CoachPaymentMethodProcessingStarted",
          properties: {
            eventType: "payment_processing",
            status: "started",
            userType: "coach",
            userRole: "coach",
            sessionId: sessionId,
            timestamp: new Date().toISOString(),
            paymentProvider: "stripe",
            action: "add_customer_payment_method",
            flow: "coach_self_service",
          },
        });

        dispatch(addCustomerPaymentMethod({ sessionId })).then((result) => {
          if (result.error) {
            console.error("Payment method addition failed:", result.error);

            // Track coach payment processing failure
            appInsights.trackEvent({
              name: "CoachPaymentMethodProcessingFailed",
              properties: {
                eventType: "payment_processing",
                status: "failed",
                userType: "coach",
                userRole: "coach",
                sessionId: sessionId,
                errorMessage:
                  result.error?.message || result.error || "Unknown error",
                errorType: result.error?.type || "unknown",
                timestamp: new Date().toISOString(),
                paymentProvider: "stripe",
                action: "add_customer_payment_method",
                flow: "coach_self_service",
              },
            });
          } else {
            localStorage.removeItem("checkoutSessionId");
            localStorage.setItem("isStripeConnected", true);
            localStorage.setItem("isCoach", false);

            // Track coach payment processing success
            appInsights.trackEvent({
              name: "CoachPaymentMethodProcessingSuccess",
              properties: {
                eventType: "payment_processing",
                status: "success",
                userType: "coach",
                userRole: "coach",
                sessionId: sessionId,
                timestamp: new Date().toISOString(),
                paymentProvider: "stripe",
                action: "add_customer_payment_method",
                flow: "coach_self_service",
                stripeConnected: true,
                localStorageCleared: true,
                localStorageUpdated: ["isStripeConnected", "isCoach"],
              },
            });
          }
        });
      } else if (isAdminCoach) {
        // Track admin coach payment processing start
        appInsights.trackEvent({
          name: "AdminCoachPaymentMethodProcessingStarted",
          properties: {
            eventType: "payment_processing",
            status: "started",
            userType: "adminCoach",
            userRole: "admin",
            sessionId: sessionId,
            leadOfferDetailsId: leadOfferDetailsId,
            coachLeadOfferId: leadOfferDetailsId,
            timestamp: new Date().toISOString(),
            paymentProvider: "stripe",
            action: "add_coach_payment_method_for_admin",
            flow: "admin_managed",
          },
        });

        dispatch(
          addCoachPaymentMethodForAdmin({
            sessionId,
            coachleadofferID: leadOfferDetailsId,
          })
        ).then((result) => {
          localStorage.removeItem("checkoutSessionId");
          localStorage.removeItem("isStripeConnected");
          localStorage.removeItem("isAdminCoach");
          localStorage.setItem("isCoach", false);

          if (result.error) {
            // Track admin coach payment processing failure
            appInsights.trackException({
              exception: new Error(result.error?.message || result.error || "Unknown error"),
              severityLevel: 2,
              properties: {
              eventType: "payment_processing",
              status: "failed",
              userType: "adminCoach",
              userRole: "admin",
              sessionId: sessionId,
              leadOfferDetailsId: leadOfferDetailsId,
              coachLeadOfferId: leadOfferDetailsId,
              errorMessage:
                result.error?.message || result.error || "Unknown error",
              errorType: result.error?.type || "unknown",
              timestamp: new Date().toISOString(),
              paymentProvider: "stripe",
              action: "add_coach_payment_method_for_admin",
              flow: "admin_managed",
              },
            });
          } else {
            // Track admin coach payment processing success
            appInsights.trackEvent({
              name: "AdminCoachPaymentMethodProcessingSuccess",
              properties: {
                eventType: "payment_processing",
                status: "success",
                userType: "adminCoach",
                userRole: "admin",
                sessionId: sessionId,
                leadOfferDetailsId: leadOfferDetailsId,
                coachLeadOfferId: leadOfferDetailsId,
                timestamp: new Date().toISOString(),
                paymentProvider: "stripe",
                action: "add_coach_payment_method_for_admin",
                flow: "admin_managed",
                localStorageCleared: true,
                localStorageUpdated: [
                  "checkoutSessionId",
                  "isStripeConnected",
                  "isAdminCoach",
                  "isCoach",
                ],
              },
            });
          }
        });
      }
    }
  }, [dispatch, sessionId, leadOfferDetailsId]);

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-blue-50">
        <div className="bg-white p-6 rounded-lg shadow-lg text-center">
          <h2>Processing your payment method...</h2>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-red-50">
        <div className="bg-white p-6 rounded-lg shadow-lg text-center">
          <h2 className="text-red-500">Error Saving Card Details</h2>
          <p className="text-red-500">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-green-50">
      <div className="bg-white p-6 rounded-lg shadow-lg text-center">
        <h2 className="text-green-600 mb-4">
          Card Details Saved Successfully!
        </h2>
        <p className="text-gray-700">
          Your card details have been securely saved for future transactions.
          <br />
          Thank you for updating your payment information.
        </p>
      </div>
    </div>
  );
};

export default StripeCoachSuccess;
